import styled from 'styled-components';
export const ContainerStyled = styled('div')(({ outlined, shadow, rounded, theme, }) => ({
    ...outlined && {
        border: `1px solid ${theme === null || theme === void 0 ? void 0 : theme.palette.grey[200]}`,
    },
    ...shadow && {
        boxShadow: theme === null || theme === void 0 ? void 0 : theme.shadows[shadow],
    },
    ...rounded && {
        borderRadius: '5px',
    },
}));
//# sourceMappingURL=Container.styles.js.map